import React from 'react';
import { Grid } from '@mui/material';
import HelpIcon from "@mui/icons-material/Help";
import ReactTooltip from "react-tooltip";
import { Tooltip, ResponsiveContainer, Treemap } from 'recharts';

const classes = {
    lblGraph: {
        backgroundColor: '#F5F5F5',
        color: '#155BCB',
        boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
        borderRadius: 3,
        height: '35px',
        display: 'flex',
        alignItems: 'center',
        padding: 10,
        marginBottom: "3px"
    },

    gridLabel: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        gap: 5
    },

    graph: {
        border: "1px solid #D1CCCC",
        boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
        height: "400px",
    },

}

export default function OccurrencesByGroup({ occurrences }) {
    const dataMap = {};

    for (let i = 0, n = occurrences.length; i < n; i++) {
        const occurrence = occurrences[i];
        const group = occurrence.group;

        if (group === undefined) {
            continue
        }

        if (!dataMap[group]) {
            dataMap[group] = { name: group, size: 0 };
        }

        dataMap[group].size += 1;
    }

    const data = Object.keys(dataMap).map(key => ({
        name: dataMap[key].name,
        size: dataMap[key].size
    }));

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
          return (
            <div style={{ backgroundColor: 'white', padding: '4px', borderRadius: '5px', boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)' }}>
              <p className="label">{`${payload[0].payload.name} : ${payload[0].value}`}</p>
            </div>
          );
        }
    
        return null;
      };


      
    return (

        <div id="total-ocurrencies-dashboard" style={{ width: "100%" }}>

            <Grid item xs={12} sm={12} md={12} lg={12} style={classes.lblGraph}>
                <div style={classes.gridLabel}>
                    <div>Ocorrências por grupo:</div>

                    <div style={classes.helpText}>
                        <ReactTooltip id="proportion-info" className="popup" />
                        <HelpIcon
                            style={{ color: "#a1a5ab" }}
                            fontSize="small"
                            data-for="proportion-info"
                            data-place="bottom"
                            data-tip="Um gráfico que mostra a quantidade de ocorrência por grupo."
                        />
                    </div>
                </div>
            </Grid>


            <Grid item xs={12} sm={12} md={12} lg={12} style={classes.graph}>

                {data.length === 0 ? (
                    <span
                        style={{
                            fontSize: "16px",
                            margin: "30px",
                            textAlign: "center",
                            display: "block",
                        }}
                    >
                        Não há ocorrências
                    </span>

                ) : (
                    <ResponsiveContainer width="100%" height={400}>
                        <Treemap
                            width={400}
                            height={200}
                            data={data}
                            dataKey="size"
                            ratio={4 / 3}
                            stroke="#fff"
                        >
                            <Tooltip content={<CustomTooltip />}  />
                        </Treemap>
                    </ResponsiveContainer>
                )}

            </Grid>

        </div>
    );
}